import api from '@pray/shared/utils/api';

import type { WarmupCampaign } from './types';

/** Any status but done; the sender, template and unsubscribe group only while draft. */
export type UpdateWarmupCampaignPayload = Partial<{
  name: string;
  subject_text: string;
  preview_text: string | null;
  /** "HH:mm" */
  send_time: string;
  schedule_timezone: string;
  respect_user_timezone: boolean;
  brake_enabled: boolean;
  /** Fractions: 0.003 is 0.3 % */
  brake_spam_rate: number;
  brake_bounce_rate: number;
  artist_sender_profile_id: string | null;
  email_template_id: string;
  unsubscribe_group_id: number | null;
}>;

export async function updateWarmupCampaign({
  artistId,
  warmupCampaignId,
  payload,
}: {
  artistId: string;
  warmupCampaignId: string;
  payload: UpdateWarmupCampaignPayload;
}): Promise<{ object: WarmupCampaign }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!warmupCampaignId) throw new Error('Warmup campaign ID is required');

  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupCampaignId}`;
  const response = await api.executePatchRequest<{ data: { object: WarmupCampaign } }>(url, payload);
  return response.data.data;
}
